
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      featuredPlayers: [],
    };
  },
  computed: {
    showFixtures () {
      return !this.post.acf.hide_fixtures;
    },
    showTable () {
      return !this.post.acf.hide_league_table;
    },
    showFeaturedPlayer () {
      return !this.post.acf.hide_featured_player;
    },
  },
  mounted () {
    this.$nextTick(() => {
      const taggedPlayers = this.getTaxonomies(this.post, `player`);
      this.featuredPlayers = taggedPlayers || [];
    });
  },
};
